import { pathMatches } from "../../shared/config";

/** Saved reviewer state is authoritative; path patterns only seed a new step. */
export function initialCollapsedFiles(
  paths: Iterable<string>,
  collapseByDefault: readonly string[],
  savedPaths?: readonly string[],
): Set<string> {
  if (savedPaths !== undefined) return new Set(savedPaths);
  return new Set([...paths].filter((path) =>
    collapseByDefault.some((pattern) => pathMatches(pattern, path))
  ));
}
